import React from "react";
import { CommandBarButton, Stack, useDisclosure } from "sprint-common-web";

import { isInvalidStatusForWaitingForClientResponse } from "../../common/types/CloudFileStatus";
import { useCloudFileDetails } from "../common/useCloudFileDetails";
import { CloudFileWaitingForClientResponseDialog } from "./CloudFileRequestWaitingForClientResponseDialog";

export const CloudFileRequestWaitingForClientResponseButton = (): JSX.Element => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    const { data: cloudFileDetails } = useCloudFileDetails();

    if (!cloudFileDetails) {
        return <></>;
    }

    return (
        <Stack>
            <CommandBarButton
                testId="cloud-file-request-waiting-for-client-response-button"
                onClick={onOpen}
                text="Request Waiting for Client Response"
                icon="HourGlass"
                disabled={isInvalidStatusForWaitingForClientResponse(cloudFileDetails?.status)}
            />
            <CloudFileWaitingForClientResponseDialog
                isOpen={isOpen}
                onClose={onClose}
                cloudFileId={cloudFileDetails?.cloudFileId}
            />
        </Stack>
    );
};
